<button [attr.disabled]="disabled || null" [ngClass]="class">
  <ng-content></ng-content>
</button>
